import { ReporteProductividadComponent } from './components/core/containers/bandeja-principal/administrador/reportes/reporte-productividad/reporte-productividad.component';
import { ActualizarRegistrosRntComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/Actualizar-registros-rnt/actualizar-registros-rnt.component";
// tslint:disable-next-line:max-line-length
import { ReportesTramitesComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/tramites/reportes-tramites.component";
// tslint:disable-next-line:max-line-length
import { ReportesRntsComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/rnts/reportes-rnts.component";
import { Routes, RouterModule, CanActivate } from "@angular/router";
import { HomeComponent } from "./components/home/container/home.component";
import { LoginComponent } from "./components/seguridad/containers/login/login.component";
import { RegistroCuentaComponent } from "./components/seguridad/containers/registrar/registro-cuenta.component";
import { CambiarContrasenaComponent } from "./components/seguridad/containers/cambiar-contrasena/cambiar-contrasena.component";
import { RecuperarContrasenaComponent } from "./components/seguridad/containers/recuperar-contrasena/recuperar-contrasena.component";
import { ContactenosComponent } from "./components/contenido/containers/contactenos/contactenos.component";
import { PreguntasFrecuentesComponent } from "./components/contenido/containers/preguntas-frecuentes/preguntas-frecuentes.component";
import { TutorialesComponent } from "./components/contenido/containers/tutoriales/tutoriales.component";
import { LegislacionComponent } from "./components/contenido/containers/legislacion/legislacion.component";
import { AuthGuardService } from "./shared/guard/auth.guard";
import { PerfilComponent } from "./components/seguridad/containers/perfil/perfil.component";
// tslint:disable-next-line:max-line-length
import { EstablecimientoComercioComponent } from "./components/core/containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.component";
import { TerminoComponent } from "./components/contenido/containers/termino/termino.component";
import { AuthExternoGuardService } from "./shared/guard/auth_externo.guard";
import { NgModule } from "@angular/core";
import { environment } from "./../environments/environment";
// tslint:disable-next-line:max-line-length
import { SolicitudesComponent as SolicitudRegistroPrestador } from "./components/core/containers/bandeja-principal/prestador/solicitudes/solicitudes.component";
// tslint:disable-next-line:max-line-length
import { SolicitudesComponent as SolicitudRegistroFuncionario } from "./components/core/containers/bandeja-principal/funcionario/solicitudes/solicitudes.component";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionComponent } from "./components/core/containers/bandeja-principal/prestador/pasos/completa-informacion/completa-informacion.component";
import { CapacidadComponent } from "./components/core/containers/bandeja-principal/prestador/pasos/capacidad/capacidad.component";
// tslint:disable-next-line:max-line-length
import { TipoEstablecimientoComponent } from "./components/core/containers/bandeja-principal/prestador/pasos/tipo-establecimiento/tipo-establecimiento.component";
// tslint:disable-next-line:max-line-length
import { CodigoConductaComponent } from "./components/core/containers/bandeja-principal/prestador/pasos/codigo-conducta/codigo-conducta.component";
// tslint:disable-next-line:max-line-length
import { OtrasSolicitudesComponent } from "./components/core/containers/bandeja-principal/prestador/otras-solicitudes/otras-solicitudes.component";
// tslint:disable-next-line:max-line-length
import { PagoParafiscalComponent } from "./components/core/containers/bandeja-principal/prestador/pasos/pago-parafiscal/pago-parafiscal.component";
// tslint:disable-next-line:max-line-length
import { AnotacionesComponent as AnotacionesTrazaRnt } from "./components/core/containers/bandeja-principal/funcionario/anotaciones/anotaciones.component";
import { CertificadosComponent } from "./components/core/containers/bandeja-principal/funcionario/trazabilidad/certificados.component";
import { RutaNoExisteComponent } from "./shared/layouts/ruta-no-existe/ruta-no-existe.component";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionGuiaComponent } from "./components/core/containers/bandeja-principal/prestador/pasos/completa-informacion-guia/completa-informacion-guia.component";
// tslint:disable-next-line:max-line-length
import { DetalleSolicitudComponent } from "./components/core/containers/bandeja-principal/funcionario/detalle-solicitud/detalle-solicitud.component";
// tslint:disable-next-line:max-line-length
import { EstablecimientoComponent } from "./components/core/containers/bandeja-principal/funcionario/opciones/establecimiento/establecimiento.component";
// tslint:disable-next-line:max-line-length
import { CapacidadFuncionarioComponent } from "./components/core/containers/bandeja-principal/funcionario/opciones/capacidad-funcionario/capacidad-funcionario.component";
import { DocumentosComponent } from "./components/core/containers/bandeja-principal/funcionario/opciones/documentos/documentos.component";
import { AuthInactiveGuardService } from "./shared/guard/auth_inactive.guard";
import { FonturComponent } from "./components/core/containers/bandeja-principal/prestador/pasos/fontur/fontur.component";
import { EncuestaComponent } from "./components/core/containers/bandeja-principal/prestador/pasos/encuesta/encuesta.component";
import { ArrendatarioComponent } from "./components/core/containers/bandeja-principal/prestador/arrendatario/arrendatario.component";
// tslint:disable-next-line:max-line-length
import { EncuestaFuncionarioComponent } from "./components/core/containers/bandeja-principal/funcionario/opciones/encuesta-funcionario/encuesta-funcionario.component";
// tslint:disable-next-line:max-line-length
import { ParafiscalesFuncionarioComponent } from "./components/core/containers/bandeja-principal/funcionario/opciones/parafiscales-funcionario/parafiscales-funcionario.component";
// tslint:disable-next-line:max-line-length
import { InformacionComponent } from "./components/core/containers/bandeja-principal/funcionario/opciones/informacion/informacion.component";
import { RntComponent } from "./components/core/containers/bandeja-principal/funcionario/rnts/rnt.component";
import { NotificacionComponent } from "./components/core/containers/bandeja-principal/prestador/notificacion/notificacion.component";
// tslint:disable-next-line:max-line-length
import { DetalleSolicitudPrestadorComponent } from "./components/core/containers/bandeja-principal/prestador/detalle-solicitud/detalle-solicitud.component";
// tslint:disable-next-line:max-line-length
import { EstablecimientoConsultaExternaComponent } from "./components/core/containers/bandeja-principal/prestador/opciones/establecimiento/establecimiento.component";
import { RolesUsuario } from "./shared/enumeraciones/roles-usuario.enum";
import { RolGuardService } from "./shared/guard/rol.guard";
import { TipoPrestador } from "./shared/enumeraciones/tipo-prestador.enum";
// tslint:disable-next-line:max-line-length
import { CompletaInformacionInmueble } from "./components/core/containers/bandeja-principal/prestador/pasos/completa-informacion-inmueble/completa-informacion-inmueble.component";
// tslint:disable-next-line:max-line-length
import { TiposRntComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/tipos-rnt/tipos-rnt.component";
import { ModalArriendoVehiculoComponent } from "./components/core/layouts/modal-arriendo-vehiculo/modal-arriendo-vehiculo.component";
// tslint:disable-next-line:max-line-length
import { ReasignacionSolicitudesComponent } from "./components/core/containers/bandeja-principal/administrador/gestion/reasignacion-solicitudes/reasignacion-solicitudes.component";
// tslint:disable-next-line:max-line-length
import { ConfigurarCapacidadTecnicaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/configurar-capacidad-tecnica/configurar-capacidad-tecnica.component";
import { SideMenu1Component } from "./components/menu/layouts/side-menu1/side-menu1.component";
import { AnotacionComponent } from "./components/core/containers/bandeja-principal/prestador/anotacion/anotacion.component";
// tslint:disable-next-line:max-line-length
import { ConfiguracionInterfazComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/configuracion-interfaz/configuracion-interfaz.component";
// tslint:disable-next-line:max-line-length
import { ConfiguracionEmailContactenosComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/configuracion-email-contactenos/configuracion-email-contactenos.component";
// tslint:disable-next-line:max-line-length
import { AccionRntComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/accion-rnt/accion-rnt.component";
// tslint:disable-next-line:max-line-length
import { ConfiguracionTipoInterfazComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/configuracion-tipo-interfaz/configuracion-tipo-interfaz.component";
import { EntornoComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/entorno/entorno.component";
import { ModuloComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/modulo/modulo.component";
// tslint:disable-next-line:max-line-length
import { MotivoDevolucionComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/motivo-devolucion/motivo-devolucion.component";
// tslint:disable-next-line:max-line-length
import { FormacionEmpleadoComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/formacion-empleado/formacion-empleado.component";
// tslint:disable-next-line:max-line-length
import { FaqSeccionComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/faq-seccion/faq-seccion.component";
// tslint:disable-next-line:max-line-length
import { ConfLegislacionComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/legislacion/legislacion.component";
// tslint:disable-next-line:max-line-length
import { OpcionRolComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/opcion-rol/opcion-rol.component";
// tslint:disable-next-line:max-line-length
import { RecursoAudiovisualComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/recurso-audiovisual/recurso-audiovisual.component";
import { RolComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/rol/rol.component";
// tslint:disable-next-line:max-line-length
import { SubcategoriaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/subcategoria/subcategoria.component";
// tslint:disable-next-line:max-line-length
import { ConfTerminosCondicionesComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/terminos-condiciones/terminos-condiciones.component";
// tslint:disable-next-line:max-line-length
import { TipoTerminosCondicionesComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/tipo-terminos-condiciones/tipo-terminos-condiciones.component";
import { UsuarioComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/usuario/usuario.component";
// tslint:disable-next-line:max-line-length
import { OpcionModuloComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/opcion-modulo/opcion-modulo.component";
// tslint:disable-next-line:max-line-length
import { ActividadesEconomicasRntComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/actividades-economicas-rnt/actividades-economicas-rnt.component";
// tslint:disable-next-line:max-line-length
import { CampoAdicionalComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/campo-adicional/campo-adicional.component";
// tslint:disable-next-line:max-line-length
import { CampoAdicionalCategoriaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/campo-adicional-categoria/campo-adicional-categoria.component";
// tslint:disable-next-line:max-line-length
import { CategoriaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/categoria/categoria.component";
// tslint:disable-next-line:max-line-length
import { ContenidoCertificadoComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/contenido-certificado/contenido-certificado.component";
// tslint:disable-next-line:max-line-length
import { DetalleTerminosCondicionesComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/detalle-terminos-condiciones/detalle-terminos-condiciones.component";
// tslint:disable-next-line:max-line-length
import { DocumentoComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/documento/documento.component";
// tslint:disable-next-line:max-line-length
import { DocumentoSubcategoriaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/documento-subcategoria/documento-subcategoria.component";
// tslint:disable-next-line:max-line-length
import { DocumentoTipoTurismoAventuraComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/documento-tipo-turismo-aventura/documento-tipo-turismo-aventura.component";
import { FaqComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/faq/faq.component";
// tslint:disable-next-line:max-line-length
import { ModuloEncuestaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/modulo-encuesta/modulo-encuesta.component";
// tslint:disable-next-line:max-line-length
import { ModuloEncuestaSubcategoriaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/modulo-encuesta-subcategoria/modulo-encuesta-subcategoria.component";
// tslint:disable-next-line:max-line-length
import { OpcionRespuestaAdicionalEncuestaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/opcion-respuesta-adicional-encuesta/opcion-respuesta-adicional-encuesta.component";
// tslint:disable-next-line:max-line-length
import { OpcionRespuestaEncuestaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/opcion-respuesta-encuesta/opcion-respuesta-encuesta.component";
// tslint:disable-next-line:max-line-length
import { ParametroComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/parametro/parametro.component";
// tslint:disable-next-line:max-line-length
import { PasoSolicitudComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/paso-solicitud/paso-solicitud.component";
// tslint:disable-next-line:max-line-length
import { PasoTipoSolicitudComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/paso-tipo-solicitud/paso-tipo-solicitud.component";
// tslint:disable-next-line:max-line-length
import { PreguntaAdicionalEncuestaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/pregunta-adicional-encuesta/pregunta-adicional-encuesta.component";
// tslint:disable-next-line:max-line-length
import { PreguntaEncuestaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/pregunta-encuesta/pregunta-encuesta.component";
// tslint:disable-next-line:max-line-length
import { SeccionEncuestaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/seccion-encuesta/seccion-encuesta.component";
// tslint:disable-next-line:max-line-length
import { SubcategoriasTopesmlvComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/subcategorias-topesmlv/subcategorias-topesmlv.component";
// tslint:disable-next-line:max-line-length
import { TipoDatoComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/tipo-dato/tipo-dato.component";
// tslint:disable-next-line:max-line-length
import { TipoIdentificacionComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/tipo-identificacion/tipo-identificacion.component";
// tslint:disable-next-line:max-line-length
import { TipoPreguntaEncuestaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/tipo-pregunta-encuesta/tipo-pregunta-encuesta.component";
// tslint:disable-next-line:max-line-length
import { TipoTurismoAventuraComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/tipo-turismo-aventura/tipo-turismo-aventura.component";
// tslint:disable-next-line:max-line-length
import { UsuarioRolComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/usuario-rol/usuario-rol.component";
// tslint:disable-next-line:max-line-length
import { EstablecimientoComercioSoloConsultaComponent } from "./components/core/containers/bandeja-principal/solo-consulta/establecimiento-comercio/establecimiento-comercio.component";
// tslint:disable-next-line:max-line-length
import { DetalleSolicitudSoloConsultaComponent } from "./components/core/containers/bandeja-principal/solo-consulta/detalle-solicitud/detalle-solicitud.component";
import { FonturFuncionarioComponent } from "./components/core/containers/bandeja-principal/funcionario/opciones/fontur/fontur.component";
// tslint:disable-next-line:max-line-length
import { CancelacionComponent } from "./components/core/containers/bandeja-principal/administrador/gestion/cancelacion/cancelacion.component";
import { SuspensionComponent } from "./components/core/containers/bandeja-principal/administrador/gestion/suspension/suspension.component";
// tslint:disable-next-line:max-line-length
import { ModuloAyudaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/modulo-ayuda/modulo-ayuda.component";
// tslint:disable-next-line:max-line-length
import { ArriendoVehiculoComponent } from "./components/core/containers/bandeja-principal/prestador/arriendo-vehiculo/arriendo-vehiculo.component";
// tslint:disable-next-line:max-line-length
import { EstadoRntComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/estado-rnt/estado-rnt.component";
// tslint:disable-next-line:max-line-length
import { EstadoSolicitudComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/estado-solicitud/estado-solicitud.component";
import { ReportesSoloConsultaComponent } from "./components/core/containers/bandeja-principal/solo-consulta/reportes/reportes.component";
// tslint:disable-next-line:max-line-length
import { CambioPropietarioComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/cambio-propietario/cambio-propietario.component";
// tslint:disable-next-line:max-line-length
import { ReactivacionComponent } from "./components/core/containers/bandeja-principal/administrador/gestion/reactivacion/reactivacion.component";
// tslint:disable-next-line:max-line-length
import { ReportesPrestadoresComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/prestadores/reportes-prestadores.component";
// tslint:disable-next-line:max-line-length
import { ConfiguracionCamaraComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/configuracion-camara/configuracion-camara.component";
// tslint:disable-next-line:max-line-length
import { SolicitudesConsultaComponent } from "./components/core/containers/bandeja-principal/funcionario/solicitudes-consulta/solicitudes-consulta.component";
import { RntConsultaComponent } from "./components/core/containers/bandeja-principal/funcionario/rnts-consulta/rnt-consulta.component";
// tslint:disable-next-line:max-line-length
import { ReportesEstablecimientosComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/establecimientos/reportes-establecimientos.component";
// tslint:disable-next-line:max-line-length
import { EstadisticosCamarasComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/estadisticos-camaras/estadisticos-camaras.component";
// tslint:disable-next-line:max-line-length
import { FormulariosComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/formularios/formularios.component";
// tslint:disable-next-line:max-line-length
import { PagosParafiscalesComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/pagos-parafiscales/pagos-parafiscales.component";
import { FonturRntComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/fontur-rnt/fontur-rnt.component";
import { ReportesAnotacionesComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/anotaciones/reportes-anotaciones.component";
import { ReversarEstadoComponent } from "./components/core/containers/bandeja-principal/administrador/gestion/reversar-estado/reversar-estado.component";
import { ReporteEncuestaComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/encuesta/reporte-encuesta.component";
import { ReporteEncuestaSatisfaccionComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/reporte-encuesta-satisfaccion/reporte-encuesta-satisfaccion.component";
import { ReportesCantidadRntComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/cantidad-rnts/reportes-cantidad-rnt.component";
import { ReportesCantidadRntEstadoComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/cantidad-rnts-estado/reportes-cantidad-rnt-estado.component";
import { SancionComponent } from "./components/core/containers/bandeja-principal/administrador/gestion/sancion/sancion.component";
import { DepositarioProvisionalComponent } from "./components/core/containers/bandeja-principal/administrador/gestion/depositario-provisional/depositario-provisional.component";
import { CapacidadTecnicaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/requisitos-generales/capacidad-tecnica/capacidad-tecnica.component";
import { CapacidadOperativaComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/requisitos-generales/capacidad-operativa/capacidad-operativa.component";
import { CompletaInformacionPlataformas } from "./components/core/containers/bandeja-principal/prestador/pasos/completa-informacion-plataformas/completa-informacion-plataformas.component";
import { ReportesCertificadosComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/certificados/reportes-certificados.component";
import { SancionesPersonasComponent } from "./components/core/containers/bandeja-principal/administrador/gestion/sanciones-personas/sanciones-personas.component";
import { ReporteSancionesPersonasComponent } from "./components/core/containers/bandeja-principal/administrador/reportes/reporte-sanciones-personas/reporte-sanciones-personas.component";
import { AtencionSolicitudComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/atencion-solicitud/atencion-solicitud.component";
import { AjustesRntComponent } from "./components/core/containers/bandeja-principal/administrador/configuracion/ajustes-rnt/ajustes-rnt.component";
import { AnotacionesAdminComponent as GestionAnotacionesAdministradorNacional } from "./components/core/containers/bandeja-principal/administrador/configuracion/anotaciones/anotaciones.component";
import { ReporteGeneralComponent } from './components/core/containers/bandeja-principal/administrador/reportes/general/reporte-general.component';
import { NotificacionesComponent } from './components/core/containers/bandeja-principal/prestador/notificaciones/notificaciones.component';
import { EncuestaSatisfaccionComponent } from './components/core/containers/bandeja-principal/administrador/configuracion/encuesta-satisfaccion/encuesta-satisfaccion.component';
import { HasPendingChangesGuard } from './shared/guard/has_pending_changes.guard';
import { AsignarSancionesPersonaComponent } from './components/core/containers/bandeja-principal/administrador/gestion/asignar-sanciones-persona/asignar-sanciones-persona.component';
import { MunicipiosSinEstudioAutomaticoComponent } from './components/core/containers/bandeja-principal/administrador/configuracion/municipios-sin-estudio-automatico/municipios-sin-estudio-automatico.component';
import { ExentoComponent } from './components/core/containers/bandeja-principal/administrador/gestion/exento/exento.component';
import {VizualizacionNoSuperadaComponent} from './components/core/containers/bandeja-principal/administrador/reportes/vizualizacion-no-superada/vizualizacion-no-superada.component';

export const ROUTES: Routes = [
  { path: "home", component: HomeComponent },
  { path: "login", component: LoginComponent },
  { path: "registrar", component: RegistroCuentaComponent },
  {
    path: "cambiarContrasena/:key",
    component: CambiarContrasenaComponent,
    canActivate: [AuthExternoGuardService],
  },
  { path: "recuperarContrasena", component: RecuperarContrasenaComponent },
  { path: "contactenos", component: ContactenosComponent },
  { path: "faq", component: PreguntasFrecuentesComponent },
  { path: "videosTutoriales", component: TutorialesComponent },
  { path: "legislacion", component: LegislacionComponent },
  { path: "terminos", component: TerminoComponent },
  { path: "", redirectTo: "/home", pathMatch: "full" },

  {
    path: "perfil",
    component: PerfilComponent,
    canActivate: [AuthGuardService],
  },
  { path: "", redirectTo: "/home", pathMatch: "full" },
  {
    path: "mis-establecimientos",
    component: EstablecimientoComercioComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: "", redirectTo: "mis-establecimientos", pathMatch: "full" },
      { path: "perfil", component: PerfilComponent },
    ],
  },
  // #region Solo consulta - urls publicas
  {
    path: "establecimientos",
    component: EstablecimientoComercioSoloConsultaComponent,
    children: [{ path: "", redirectTo: "establecimientos", pathMatch: "full" }],
  },
  {
    path: "ver-detalle/:codigo_camara/:solicitud_id",
    component: DetalleSolicitudSoloConsultaComponent,
    children: [
      {
        path: "establecimientos",
        component: EstablecimientoConsultaExternaComponent,
      },
    ],
  },
  {
    path: "reportes",
    component: ReportesSoloConsultaComponent,
    children: [{ path: "", redirectTo: "reportes", pathMatch: "full" }],
  },
  // #endregion
  {
    path: "otra-solicitudes",
    component: OtrasSolicitudesComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "arrendatario",
    component: ArrendatarioComponent,
    canActivate: [AuthGuardService],
  },

  // admin CC
  {
    path: "admin",
    component: SideMenu1Component,
    data: {
      roles: [
        RolesUsuario.AdministradorCC,
        RolesUsuario.AdministradorSuper,
        RolesUsuario.SoloConsultaNacional,
      ],
    },
    canActivate: [AuthGuardService],
    children: [
      { path: "", redirectTo: "reasignacion", pathMatch: "full" },
      {
        path: "reportes-rnts",
        component: ReportesRntsComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reporte-general",
        component: ReporteGeneralComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-certificados",
        component: ReportesCertificadosComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-cantidad-rnt",
        component: ReportesCantidadRntComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-prestadores",
        component: ReportesPrestadoresComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-establecimientos",
        component: ReportesEstablecimientosComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-tramites",
        component: ReportesTramitesComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-estadisticos-camaras",
        component: EstadisticosCamarasComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-formularios",
        component: FormulariosComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-pagos-parafiscales",
        component: PagosParafiscalesComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-fontur-rnt",
        component: FonturRntComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-anotaciones",
        component: ReportesAnotacionesComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-encuesta",
        component: ReporteEncuestaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reporte-encuesta-satisfaccion",
        component: ReporteEncuestaSatisfaccionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-cantidad-rnt-estado",
        component: ReportesCantidadRntEstadoComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-sanciones-personas",
        component: ReporteSancionesPersonasComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-productividad",
        component: ReporteProductividadComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reportes-vizualizacion-no-superada",
        component: VizualizacionNoSuperadaComponent,
        canActivate: [AuthGuardService],
      },
    ],
  },
  //admin shared
  {
    path: "admin",
    component: SideMenu1Component,
    data: {
      roles: [RolesUsuario.AdministradorCC, RolesUsuario.AdministradorSuper, RolesUsuario.Funcionario],
    },
    canActivate: [AuthGuardService],
    children: [

      {
        path: "sanciones-personas",
        component: SancionesPersonasComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "sanciones-personas-asignacion",
        component: AsignarSancionesPersonaComponent,
        canActivate: [AuthGuardService],
      },

    ]
  },
  {
    path: "admin",
    component: SideMenu1Component,
    data: {
      roles: [RolesUsuario.AdministradorCC, RolesUsuario.AdministradorSuper],
    },
    canActivate: [AuthGuardService],
    children: [
      { path: "", redirectTo: "reasignacion", pathMatch: "full" },
      {
        path: "reasignacion",
        component: ReasignacionSolicitudesComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reversar-estado",
        component: ReversarEstadoComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "cancelacion",
        component: CancelacionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "suspension",
        component: SuspensionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "sanciones",
        component: SancionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "exento",
        component: ExentoComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "depositario-provisional",
        component: DepositarioProvisionalComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "reactivacion",
        component: ReactivacionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "email-contactenos",
        component: ConfiguracionEmailContactenosComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "usuario-rol",
        component: UsuarioRolComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "usuario",
        component: UsuarioComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "cambio-propietario",
        component: CambioPropietarioComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "actualizar-registros-rnt",
        component: ActualizarRegistrosRntComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "configuracion-camara",
        component: ConfiguracionCamaraComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "pregunta-adicional-encuesta",
        component: PreguntaAdicionalEncuestaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "opcion-respuesta-adicional-encuesta",
        component: OpcionRespuestaAdicionalEncuestaComponent,
        canActivate: [AuthGuardService],
      }, {
        path: "notificaciones-correos-masivos",
        canActivate: [AuthGuardService],
        data: {
          roles: [RolesUsuario.AdministradorSuper, RolesUsuario.AdministradorCC],
        },
        loadChildren: () =>
          import(
            "./components/core/containers/bandeja-principal/administrador/notificaciones-correos-masivos/notificaciones-correos-masivos.module"
          ).then((x) => x.NotificacionesCorreosMasivosModule)
      },
    ],
  },

  // admin Nacional
  {
    path: "admin",
    component: SideMenu1Component,
    data: {
      roles: [RolesUsuario.AdministradorSuper],
    },
    canActivate: [AuthGuardService],
    children: [
      { path: "", redirectTo: "reasignacion", pathMatch: "full" },
      {
        path: "configurar-capacidad",
        component: ConfigurarCapacidadTecnicaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "tipos-rnt",
        component: TiposRntComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "ajustes-rnt",
        component: AjustesRntComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "interfaz",
        component: ConfiguracionInterfazComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "tipo-interfaz",
        component: ConfiguracionTipoInterfazComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "email-contactenos",
        component: ConfiguracionEmailContactenosComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "acciones-rnt",
        component: AccionRntComponent,
        canActivate: [AuthGuardService],
      },
      // { path: 'estado-rnt', component: EstadoRntComponent, canActivate: [AuthGuardService] },
      // { path: 'estado-solicitud', component: EstadoSolicitudComponent, canActivate: [AuthGuardService] },
      {
        path: "entorno",
        component: EntornoComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "modulo",
        component: ModuloComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "motivo-devolucion",
        component: MotivoDevolucionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "legislacion",
        component: ConfLegislacionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "formacion-empleado",
        component: FormacionEmpleadoComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "faq-seccion",
        component: FaqSeccionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "opcion-rol",
        component: OpcionRolComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "recurso-audiovisual",
        component: RecursoAudiovisualComponent,
        canActivate: [AuthGuardService],
      },
      { path: "rol", component: RolComponent, canActivate: [AuthGuardService] },
      {
        path: "subcategoria",
        component: SubcategoriaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "terminos-condiciones",
        component: ConfTerminosCondicionesComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "tipo-terminos-condiciones",
        component: TipoTerminosCondicionesComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "opcion-modulo",
        component: OpcionModuloComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "actividades-economicas-rnt",
        component: ActividadesEconomicasRntComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "campo-adicional",
        component: CampoAdicionalComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "campo-adicional-categoria",
        component: CampoAdicionalCategoriaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "categoria",
        component: CategoriaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "contenido-certificado",
        component: ContenidoCertificadoComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "detalle-terminos-condiciones",
        component: DetalleTerminosCondicionesComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "documento",
        component: DocumentoComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "documento-subcategoria",
        component: DocumentoSubcategoriaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "documento-tipo-turismo-aventura",
        component: DocumentoTipoTurismoAventuraComponent,
        canActivate: [AuthGuardService],
      },
      { path: "faq", component: FaqComponent, canActivate: [AuthGuardService] },
      {
        path: "modulo-encuesta",
        component: ModuloEncuestaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "modulo-encuesta-subcategoria",
        component: ModuloEncuestaSubcategoriaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "opcion-respuesta-encuesta",
        component: OpcionRespuestaEncuestaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "parametro",
        component: ParametroComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "paso-solicitud",
        component: PasoSolicitudComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "paso-tipo-solicitud",
        component: PasoTipoSolicitudComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "pregunta-encuesta",
        component: PreguntaEncuestaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "seccion-encuesta",
        component: SeccionEncuestaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "subcategorias-topesmlv",
        component: SubcategoriasTopesmlvComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "tipo-dato",
        component: TipoDatoComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "tipo-identificacion",
        component: TipoIdentificacionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "tipo-pregunta-encuesta",
        component: TipoPreguntaEncuestaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "tipo-turismo-aventura",
        component: TipoTurismoAventuraComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "modulo-ayuda",
        component: ModuloAyudaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "capacidad-tecnica",
        component: CapacidadTecnicaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "capacidad-operativa",
        component: CapacidadOperativaComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "atencion-solicitud",
        component: AtencionSolicitudComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "anotaciones",
        component: GestionAnotacionesAdministradorNacional,
        canActivate: [AuthGuardService],
      },
      {
        path: "encuesta-satisfaccion",
        component: EncuestaSatisfaccionComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "municipios-sin-estudio-automatico",
        component: MunicipiosSinEstudioAutomaticoComponent,
        canActivate: [AuthGuardService],
      },

    ],
  },
  // Temporales para admin
  {
    path: "notificacion",
    component: NotificacionComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "anotacion",
    component: AnotacionComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "vehiculos",
    component: ArriendoVehiculoComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "solicitud",
    component: SolicitudRegistroPrestador,
    data: {
      roles: [RolesUsuario.Prestador],
    },
    canActivate: [AuthGuardService],
    children: [
      { path: "", redirectTo: "mis-establecimientos", pathMatch: "full" },
      { path: "completa-informacion", component: CompletaInformacionComponent },
      {
        path: "completa-informacion-inmueble",
        component: CompletaInformacionInmueble,
      },
      {
        path: "completa-informacion-guia",
        component: CompletaInformacionGuiaComponent,
        data: { rol: [TipoPrestador.Guia, TipoPrestador.Comerciante] },
        canActivate: [RolGuardService],
      },
      {
        path: "completa-informacion-plataformas",
        component: CompletaInformacionPlataformas,
      },
      { path: "capacidad", component: CapacidadComponent },
      { path: "tipo-establecimiento", component: TipoEstablecimientoComponent },
      { path: "codigo-conducta", component: CodigoConductaComponent },
      { path: "pago-parafiscal", component: PagoParafiscalComponent },
      { path: "encuesta", component: EncuestaComponent, canDeactivate: [HasPendingChangesGuard] },
      { path: "fontur", component: FonturComponent },
    ],
  },
  {
    // tslint:disable-next-line:max-line-length
    path: "solicitud-registro-funcionario",
    component: SolicitudRegistroFuncionario,
    canActivate: [AuthGuardService],
    data: {
      roles: [
        RolesUsuario.Funcionario,
        // RolesUsuario.AdministradorCC,
        RolesUsuario.AdministradorSuper,
      ],
    },
    children: [
      {
        path: "",
        redirectTo: "solicitud-registro-funcionario",
        pathMatch: "full",
      },
      { path: "perfil", component: PerfilComponent },
    ],
  },
  {
    path: "historial-solicitud",
    component: RntComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [
        RolesUsuario.Funcionario,
        // RolesUsuario.AdministradorCC,
        RolesUsuario.AdministradorSuper,
      ],
    },
    children: [
      { path: "", redirectTo: "historial-solicitud", pathMatch: "full" },
    ],
  },
  {
    path: "reversar-estado",
    component: ReversarEstadoComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [RolesUsuario.Funcionario, RolesUsuario.AdministradorCC],
    },
  },
  {
    // tslint:disable-next-line:max-line-length
    path: "solicitud-registro-consulta",
    component: SolicitudesConsultaComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [RolesUsuario.SoloConsulta, RolesUsuario.SoloConsultaNacional],
    },
    children: [
      {
        path: "",
        redirectTo: "solicitud-registro-consulta",
        pathMatch: "full",
      },
      { path: "perfil", component: PerfilComponent },
    ],
  },
  {
    path: "historial-consulta",
    component: RntConsultaComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [RolesUsuario.SoloConsulta, RolesUsuario.SoloConsultaNacional],
    },
    children: [
      { path: "", redirectTo: "historial-consulta", pathMatch: "full" },
    ],
  },
  {
    path: "detalle-solicitud",
    component: DetalleSolicitudComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: "",
        redirectTo: "solicitud-registro-funcionario",
        pathMatch: "full",
      },
      { path: "establecimientos", component: EstablecimientoComponent },
      { path: "capacidad", component: CapacidadFuncionarioComponent },
      { path: "documentos", component: DocumentosComponent },
      { path: "encuesta-funcionario", component: EncuestaFuncionarioComponent },
      {
        path: "parafiscales-funcionario",
        component: ParafiscalesFuncionarioComponent,
      },
      { path: "fontur", component: FonturFuncionarioComponent },
      { path: "informacion", component: InformacionComponent },
    ],
  },
  {
    // tslint:disable-next-line:max-line-length
    path: "detalle-consulta-solicitud/:key",
    component: DetalleSolicitudPrestadorComponent,
    canActivate: [AuthExternoGuardService],
    children: [
      { path: "", redirectTo: "login", pathMatch: "full" },
      {
        path: "establecimientos",
        component: EstablecimientoConsultaExternaComponent,
      },
    ],
  },
  {
    path: "anotaciones",
    component: AnotacionesTrazaRnt,
    canActivate: [AuthGuardService],
  },
  {
    path: "certificados-generados",
    component: CertificadosComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "pagina-no-disponible",
    component: RutaNoExisteComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "notificaciones",
    component: NotificacionesComponent,
    canActivate: [AuthGuardService],
    data: {
      roles: [RolesUsuario.Prestador],
    },
  },
  { path: "**", redirectTo: "pagina-no-disponible" },
];

export function enableDebug() {
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow["__env"] || {};
  // Assign environment variables from browser window to env
  // In the current implementation, properties from env.js overwrite defaults from the EnvService.
  // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
  // tslint:disable-next-line:forin
  for (const key in browserWindowEnv) {
    if (browserWindowEnv.hasOwnProperty(key) && "production" === key) {
      return window["__env"][key];
    }
  }

  return false;
}

@NgModule({
  imports: [
    RouterModule.forRoot(
      ROUTES,
      {
        enableTracing: !environment.production,
        relativeLinkResolution: "legacy",
      } /* <-- debugging purposes only*/ /* <-- debugging purposes only*/
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutesModule { }
